import { inject } from '@angular/core';
import { AiRequestContextContributor } from '@panaya/ai-chat/domain';
import { CanvasFrameStore } from './canvas-frame.store';
import { CANVAS_CONTENT_CONTRIBUTOR, NO_CONTENT_CONTRIBUTOR } from './canvas-content-contributor';

/** `context.canvas` is present only while a canvas is open; the frame adds `action` per prompt. */
export function createCanvasRequestContextContributor(): AiRequestContextContributor {
    const frameStore = inject(CanvasFrameStore);
    const content = inject(CANVAS_CONTENT_CONTRIBUTOR, { optional: true }) ?? NO_CONTENT_CONTRIBUTOR;
    return () => {
        const flow = frameStore.flow();
        if (!frameStore.isOpen() || !flow) {
            return {};
        }
        return { canvas: { flow, ...content.requestContext() } };
    };
}
